class Nav {
  burgers = document.querySelectorAll('.burger');
  nav = document.querySelector('.nav');
  exit = document.querySelector('.nav__exit');

  rootLinks = [
    ...document.querySelectorAll('.header a'),
    ...document.querySelectorAll('.main a'),
    ...document.querySelectorAll('.footer a'),
    ...document.querySelectorAll('.header button'),
    ...document.querySelectorAll('.main button'),
    ...document.querySelectorAll('.footer button'),
  ];

  navLinks = [
    ...document.querySelectorAll('.nav a'),
    ...document.querySelectorAll('.nav button'),
  ];

  constructor() {
    this.burgers.forEach(burger => burger?.addEventListener('click', () => this.toggleNav()));
    this.exit?.addEventListener('click', () => this.toggleNav());

    window.addEventListener('keydown', e => {
      if (e.key == 'Escape' && this.nav?.classList.contains('active')) {
        this.toggleNav();
      }
    });
  
    this.updateLinks();
  }

  toggleNav() {
    this.nav?.classList.toggle('active');
    document.body.classList.toggle('active');

    this.updateLinks();
  }

  updateLinks() {
    if (this.nav?.classList.contains('active')) {
      this.rootLinks.forEach(link => {
        link?.setAttribute('tabindex', -1);
        link?.setAttribute('aria-disabled', true);
      });

      this.navLinks.forEach(link => {
        link?.removeAttribute('tabindex');
        link?.removeAttribute('aria-disabled');
      });
    }
    else {
      this.rootLinks.forEach(link => {
        link?.removeAttribute('tabindex');
        link?.removeAttribute('aria-disabled');
      });

      this.navLinks.forEach(link => {
        link?.setAttribute('tabindex', -1);
        link?.setAttribute('aria-disabled', true);
      });
    }
  }
}

export default Nav;
